import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatDrawer} from '@angular/material/sidenav';
import {Router, RouterEvent} from '@angular/router';
import {ReplaySubject, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  @ViewChild(MatDrawer) matSidenav: MatDrawer;
  @Input() configs: Array<Config>;

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  reset(): void {
    this.configs.forEach(el => el.show = false);
  }

  toggleListElements(config: Config, forceShow = false): void {
    const cache = config.show;
    this.configs.forEach(el => el.show = false);
    if (forceShow) {
      config.show = true;
    } else {
      config.show = !cache;
    }
  }
}

export interface Config {
  icon: string;
  title: string;
  show: boolean;
  items: Array<ConfigElementList>;
  route?: string;
  parentPath: string;
  disabled: boolean;
}

export interface ConfigElementList {
  icon: string;
  route: string;
  title: string;
  disabled: boolean;
  hidden?: boolean;
  badge?: Subject<string|number>;
}
